import React from 'react';
import PropTypes from 'prop-types';
import ReactRating from 'react-rating';
import cx from 'classnames';

const Rating = ({
    className = '',
    readonly = true,
    direction = 'horizontal',
    fractions = 1,
    title = '',
    titleWidth = 'auto',
    bottomRate = 0,
    topRate = 5,
    score = null,
    size = 'small',
    empty = 'far fa-star main-blue',
    full = 'fas fa-star main-blue',
    feedback = [],
    showScore = true,
    onChange = () => {},
}) => {

    score = Number(score);
    const _score = score >= 5 ? 5 : score;

    return (
        <div className={cx('ds-stars', direction, className)}>
            <span className="dsl-m12" style={{ width: titleWidth }}>
                {title}
            </span>
            <div>
                <div className={`star-list ${size} d-flex jc-center w-auto`}>
                    <ReactRating
                        start={bottomRate}
                        stop={topRate}
                        initialRating={_score}
                        emptySymbol={empty}
                        fullSymbol={full}
                        fractions={fractions}
                        readonly={readonly}
                        onChange={(e) => onChange(e)}
                    />
                    {showScore && (
                        <span className={cx('d-none d-lg-block ms-2 ssm-t-1', size === 'small' && 'dsl-p16 lh18', size === 'medium' && 'dsl-p20', size === 'large' && 'dsl-p25')}>
                            {_score === 'N/A' ? _score : Number(_score).toFixed(1)}
                        </span>
                    )}
                </div>
                {feedback && feedback.length > 0 && (
                    <div className="rating-feedback">
                        {feedback.map((item, idx) => (
                            <p className="dsl-m12 mb-0" key={`feedback-${idx}`}>
                                {item}
                            </p>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

Rating.propTypes = {
    className: PropTypes.string,
    readonly: PropTypes.bool,
    direction: PropTypes.oneOf(['vertical', 'horizontal']),
    fractions: PropTypes.number,
    title: PropTypes.string,
    titleWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    bottomRate: PropTypes.number,
    topRate: PropTypes.number,
    score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    empty: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]),
    full: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]),
    feedback: PropTypes.array,
    showScore: PropTypes.bool,
    onChange: PropTypes.func,
};

export default Rating;
